export default __webpack_public_path__ + "static/media/add-widget-button-white.cde40d99.svg";